import React from 'react';
import withLabelAndMeta from './withLabelandMeta';
import {
  ViewWrapper, ViewLayout, Column, Row, Box,
} from './ViewLayout.styles';
import { mapViewLayoutToComponents } from '../../helpers';

const FIELD_NAME = 'dashboardLayouts';

const ELEMENT_MAPPINGS = {
  row: { component: Row, requiredProps: ['height'] },
  column: { component: Column, requiredProps: ['width'] },
  layoutBox: { component: Box, requiredProps: [] },
};

const checkIfActiveLayout = (dashboard, context, id) => {
  const layout = dashboard[FIELD_NAME] && dashboard[FIELD_NAME].find(l => l.context === context);
  return layout && layout.viewLayout === id;
};

const setLayout = ({ dashboardLayouts }, context, id) => dashboardLayouts
  .map(l => l.context === context
    ? { ...l, viewLayout: id }
    : l);

const ViewLayoutList = ({
  setFieldValue,
  lookupData: { viewLayouts = [], context },
  values,
  sideEffectHandler,
}) => (
  <ViewWrapper>
    {viewLayouts.map(viewLayout => (
      <ViewLayout
        key={viewLayout.pk}
        onClick={() => {
          const value = setLayout(values, context, viewLayout.pk);
          setFieldValue(FIELD_NAME, value);
          sideEffectHandler[FIELD_NAME](value.find(l => l.context === context));
        }}
        bg={checkIfActiveLayout(values, context, viewLayout.pk) ? 'clientPrimary' : 'greyscale.2'}
        mr="8px"
        mt="8px"
      >
        {mapViewLayoutToComponents(viewLayout.boxLayout, ELEMENT_MAPPINGS)}
      </ViewLayout>
    ))}
  </ViewWrapper>
);
export default withLabelAndMeta(ViewLayoutList);
